// extracted by css-extract-rspack-plugin
export default {"root":"_38kw9I0iV0IahexGc7UJLx","section":"ONPlWadFobgIbZOfvRwHj","header":"_2YBZ5eOtaHCQ3wOwD6ktg8","alert":"wGSIodN4i62YMoVc3Zruu","alertIcon":"sSYkXAfF7h26cNXKHET1D"};